import toastr from "toastr";
import ajax from "@/common/ajax";

export default class VkService {
    constructor() {
        this.url = "api/Vk/";
    }

    getCourseStudentsVk(courseGroupId) {
        return ajax.get(this.url + "GetCourseStudentsVk", { courseGroupId }).fail(response => toastr.error(response.responseJSON.message));
    }

    synchronizeVkUsersByHtml(htmlText) {
        return ajax.post(this.url + "SynchronizeVkUsersByHtml", htmlText).fail(response => toastr.error(response.responseJSON.message));
    }

    isVkServiceDisabled() {
        return ajax.get(this.url + "IsVkServiceDisabled").fail(response => toastr.error(response.responseJSON.message));
    }
}